// ** Redux Imports
import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './reducer';
// import SentryUtility from '@src/utility/Sentry'
// import { createLogger } from 'redux-logger'

// const logger = createLogger({
//   collapsed: true,
//   diff: true
// })

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware({
      serializableCheck: false
    });
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
